import axiosBackend from "../config/axios/axios-back-end";

const getProjects = async () => {
  const res = await axiosBackend.get("/api/projects");
  return res.data;
};

const getProject = async (id) => {
  const res = await axiosBackend.get(`/api/projects/${id}`);
  return res.data;
};

const getProjectHotels = async (id) => {
  const res = await axiosBackend.get(`/api/projects/${id}/hotels`);
  return res.data;
};

const getProjectReportCategories = async (id) => {
  const res = await axiosBackend.get(`/api/projects/${id}/report-categories`);
  return res.data;
};

const getProjectDistinctReportNames = async (id, queryData = {}) => {
  const res = await axiosBackend.get(`/api/projects/${id}/reports/distinct`, {
    params: queryData,
  });
  return res.data;
};

const getProjectPMSDistinctReportNamesByReportType = async (
  projectId,
  pmsId,
  reportType,
) => {
  const res = await axiosBackend.get(
    `/api/projects/${projectId}/pms/${pmsId}/reports/distinct`,
    {
      params: {
        shedule_type: reportType,
      },
    },
  );
  return res.data;
};

const getProjectReports = async (id, queryData) => {
  const res = await axiosBackend.get(`/api/projects/${id}/reports`, {
    params: queryData,
  });
  return res.data;
};

const getProjectSmartScan = async (id) => {
  const res = await axiosBackend.get(`/api/projects/${id}/smart-scan`);
  return res.data;
};

const getProjectHotelPMS = async (id) => {
  const res = await axiosBackend.get(`/api/projects/${id}/hotels/pms`);
  return res.data;
};

const getProjectHotelsForPMS = async (projectId, pmsId) => {
  const res = await axiosBackend.get(
    `/api/projects/${projectId}/pms/${pmsId}/hotels`,
  );
  return res.data;
};

const getProjectHotelsSubHeaderData = async (projectId) => {
  const res = await axiosBackend.get(
    `/api/projects/${projectId}/hotels/sub-header-data`,
  );
  return res.data;
};

const getHotelSubHeaderData = async (hotelId, projectId) => {
  const res = await axiosBackend.get(
    `/api/projects/${projectId}/hotels/${hotelId}/sub-header-data`,
  );
  return res.data;
};

const getProjectIndexes = async (id) => {
  const res = await axiosBackend.get(`/api/projects/${id}/indexes`);
  return res.data;
};

export {
  getProjects,
  getProject,
  getProjectHotels,
  getProjectReportCategories,
  getProjectDistinctReportNames,
  getProjectPMSDistinctReportNamesByReportType,
  getProjectReports,
  getProjectSmartScan,
  getProjectHotelPMS,
  getProjectHotelsForPMS,
  getProjectHotelsSubHeaderData,
  getHotelSubHeaderData,
  getProjectIndexes,
};
